import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { IconToggleHeartOn12, IconFinancePercent12 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import { createElement, ReactNode } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import * as styles from './styles.css';

interface IIconProps {
  isFavorite?: boolean;
  isPromo?: boolean;
  isActive?: boolean;
  isViewed?: boolean;
  isPromoBalloon?: boolean;
  isRedesign?: boolean;
}

export const Icon = ({
  isFavorite,
  isPromo,
  isActive,
  isViewed,
  isPromoBalloon,
  isRedesign,
}: IIconProps): ReactNode => {
  if (isFavorite) {
    let color: TColors;

    if (isRedesign) {
      color = isActive ? 'control-negative-primary-default' : 'control-inverted-primary-default';
    } else {
      color = isPromoBalloon && isActive ? 'icon-inverted-default' : 'icon-negative-default';
    }

    return (
      <div
        className={clsx(isActive && styles['favorite-icon--active'], isRedesign && styles['favorite-icon--redesign'])}
      >
        {createElement(IconToggleHeartOn12, { color })}
      </div>
    );
  }

  if (isPromo) {
    let color: TColors = isViewed ? 'icon-primary-disabled' : 'icon-positive-default';
    if (isActive) {
      color = 'icon-inverted-default';
    }

    return createElement(IconFinancePercent12, { color });
  }

  return null;
};

export const getIcon = (props: IIconProps) => renderToStaticMarkup(<Icon {...props} />);
